import { NumericSmoking } from "../numeric-smoking";
import componentStateMapper from "../componentsStateMapper";

class NumericSmokingWithoutLabels extends NumericSmoking {}
NumericSmokingWithoutLabels.defaultProps = {
  isLabelHidden: true
};

export default componentStateMapper(NumericSmokingWithoutLabels);
